var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1746673755924,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 13103,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1024v1024H0V0z",
    fill: "#202425",
    opacity: 0.01,
    "p-id": 13104
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.266667 307.2a136.533333 136.533333 0 0 1 136.533333-136.533333h614.4a136.533333 136.533333 0 0 1 136.533333 136.533333v512a136.533333 136.533333 0 0 1-136.533333 136.533333H204.8a136.533333 136.533333 0 0 1-136.533333-136.533333V307.2z",
    fill: "#B2E4C1",
    "p-id": 13105,
    "data-spm-anchor-id": "a313x.search_index.0.i8.5aa73a81jhwwH3",
    className: "selected"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.266667 136.533333a51.2 51.2 0 1 0-102.4 0v102.4a51.2 51.2 0 1 0 102.4 0V136.533333z m477.866666 0a51.2 51.2 0 0 0-102.4 0v102.4a51.2 51.2 0 0 0 102.4 0V136.533333z m153.6 204.8H68.266667v477.866667a136.533333 136.533333 0 0 0 136.533333 136.533333h614.4a136.533333 136.533333 0 0 0 136.533333-136.533333V341.333333z",
    fill: "#228B22",
    "p-id": 13106,
    "data-spm-anchor-id": "a313x.search_index.0.i7.5aa73a81jhwwH3",
    className: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M752.981333 475.818667a51.2 51.2 0 0 1 0 72.362666l-238.933333 238.933334a51.2 51.2 0 0 1-72.362667 0l-136.533333-136.533334a51.2 51.2 0 0 1 72.362667-72.362666L477.866667 678.5024l202.752-202.752a51.2 51.2 0 0 1 72.362666 0z",
    fill: "#FFFFFF",
    "p-id": 13107,
    "data-spm-anchor-id": "a313x.search_index.0.i9.5aa73a81jhwwH3",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTask);
export default __webpack_public_path__ + "static/media/success-task.adccfeb979faa5d1775bc5523e784f31.svg";
export { ForwardRef as ReactComponent };